import { ElementsIconProps } from '../components';

export function PencilIcon(props: ElementsIconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.49902 14.5511V17.0844C2.49902 17.3178 2.68236 17.5011 2.91569 17.5011H5.44902C5.55736 17.5011 5.66569 17.4594 5.74069 17.3761L14.8407 8.28443L11.7157 5.15943L2.62402 14.2511C2.54069 14.3344 2.49902 14.4344 2.49902 14.5511ZM17.2574 5.86776C17.5824 5.54276 17.5824 5.01776 17.2574 4.69276L15.3074 2.74276C15.1517 2.58672 14.9403 2.49902 14.7199 2.49902C14.4994 2.49902 14.288 2.58672 14.1324 2.74276L12.6074 4.26776L15.7324 7.39276L17.2574 5.86776Z"
        fill={'currentColor'}
      />
      <mask
        id="mask0_531_29114"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="16"
        height="16"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.49902 14.5511V17.0844C2.49902 17.3178 2.68236 17.5011 2.91569 17.5011H5.44902C5.55736 17.5011 5.66569 17.4594 5.74069 17.3761L14.8407 8.28443L11.7157 5.15943L2.62402 14.2511C2.54069 14.3344 2.49902 14.4344 2.49902 14.5511ZM17.2574 5.86776C17.5824 5.54276 17.5824 5.01776 17.2574 4.69276L15.3074 2.74276C15.1517 2.58672 14.9403 2.49902 14.7199 2.49902C14.4994 2.49902 14.288 2.58672 14.1324 2.74276L12.6074 4.26776L15.7324 7.39276L17.2574 5.86776Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_531_29114)"></g>
    </svg>
  );
}
